globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import * as React from 'react';
import { getTimeDifference } from '@restworld/utils-common';
import { Title, Card, Paragraph, Rating } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CardReview = function CardReview(_ref) {
  var author_name = _ref.author_name,
      rating = _ref.rating,
      time = _ref.time,
      text = _ref.text;
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "primary50",
      children: [/*#__PURE__*/_jsx(Title, {
        content: author_name
      }), /*#__PURE__*/_jsxs(CardBodyWrapper, {
        children: [/*#__PURE__*/_jsx(Rating, {
          rating: rating
        }), /*#__PURE__*/_jsx(Title, {
          content: getTimeDifference(time),
          fontWeight: "light"
        })]
      }), /*#__PURE__*/_jsx(Paragraph, {
        content: text
      })]
    })
  });
};
export default CardReview;

var CardWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardreview__CardWrapper",
  componentId: "sc-7jllaj-0"
})({
  "width": "100%",
  "gap": "0.5rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var CardBodyWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardreview__CardBodyWrapper",
  componentId: "sc-7jllaj-1"
})({
  "display": "flex",
  "gap": "0.5rem"
});